export enum ImageTypeBreakpointEnum {
  generic = 1,
  xs = 2,
  md = 3,
  lg = 4,
  xl = 5,
  xxl = 6,
  sm = 7,
}
